const CRO = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
      fill="#103F68"
    />
    <path
      d="M9.98474 1.61774L17.25 5.80213V14.1969L9.99313 18.3935L9.93437 18.379L2.75 14.1969V5.80213L9.93437 1.61774H9.98474ZM9.96108 2.48621L3.51316 6.24095V13.7581L9.96032 17.512L10.7479 17.0564L16.4868 13.7558V6.24247L10.7479 2.92274L9.96108 2.48621ZM4.51213 10.5833L6.42079 9.15621L8.10813 10.2338V12.1722L9.38489 13.4024L9.38413 13.9794L8.15392 15.1317H7.11526L4.51213 10.5833ZM10.5434 13.9809L10.5411 13.4009L11.8133 12.1722V10.2338L13.4823 9.14247L15.3871 10.5841L12.7977 15.1188H11.7721L10.5434 13.9809ZM8.73468 10.2338L8.11347 8.6075H11.8056L11.1966 10.2338L11.3767 12.0516L9.95192 12.0547L8.54389 12.057L8.73468 10.2338ZM9.95192 8.16182L6.44292 8.16029L7.09542 5.24503H12.7916L13.4785 8.1641L9.95192 8.16182Z"
      fill="white"
    />
  </svg>
);
export default CRO;
